document.querySelectorAll('body.single-product').forEach((productPage) => {
	const modal = productPage.querySelector('.product-reviews-modal');
	const closeButton = modal?.querySelector('.product-reviews-modal-close');
	const triggers = productPage.querySelectorAll('a.woocommerce-review-link');

	if (!modal || !closeButton || triggers.length === 0) {
		return;
	}

	let activeTrigger = null;
	let activePaginationRequest = null;

	const showReviewForm = () => {
		const reviewFormWrapper = modal.querySelector('#review_form_wrapper');
		const writeReviewButton = modal.querySelector('.product-reviews-write-review');

		if (!reviewFormWrapper || !writeReviewButton) {
			return;
		}

		reviewFormWrapper.hidden = false;
		writeReviewButton.setAttribute('aria-expanded', 'true');
		reviewFormWrapper.querySelector('#comment, #rating, #author')?.focus();
	};

	const updateReviews = async (url) => {
		const currentReviews = modal.querySelector('#comments');

		if (!currentReviews) {
			window.location.href = url;
			return;
		}

		if (activePaginationRequest) {
			activePaginationRequest.abort();
		}

		const controller = new AbortController();
		activePaginationRequest = controller;
		currentReviews.setAttribute('aria-busy', 'true');

		try {
			const response = await fetch(url, {
				signal: controller.signal,
				headers: {
					'X-Requested-With': 'XMLHttpRequest',
				},
			});

			if (!response.ok) {
				throw new Error(`Unexpected response: ${response.status}`);
			}

			const html = await response.text();
			const parser = new DOMParser();
			const documentFragment = parser.parseFromString(html, 'text/html');
			const nextReviews = documentFragment.querySelector('#comments');

			if (!nextReviews) {
				throw new Error('Missing reviews markup in response');
			}

			currentReviews.replaceWith(nextReviews);
		} catch (error) {
			if (error.name !== 'AbortError') {
				window.location.href = url;
			}
		} finally {
			if (activePaginationRequest === controller) {
				activePaginationRequest = null;
			}

			modal.querySelector('#reviews')?.removeAttribute('aria-busy');
		}
	};

	triggers.forEach((trigger) => {
		trigger.setAttribute('aria-controls', modal.id);
		trigger.setAttribute('aria-haspopup', 'dialog');
		trigger.setAttribute('aria-expanded', 'false');

		trigger.addEventListener('click', (event) => {
			event.preventDefault();
			activeTrigger = trigger;
			modal.showModal();
			trigger.setAttribute('aria-expanded', 'true');
		});
	});

	closeButton.addEventListener('click', () => {
		modal.close();
	});

	modal.addEventListener('click', (event) => {
		const writeReviewButton = event.target.closest('.product-reviews-write-review');

		if (writeReviewButton) {
			event.preventDefault();
			showReviewForm();
			return;
		}

		const paginationLink = event.target.closest('#reviews .woocommerce-pagination a');

		if (!paginationLink) {
			return;
		}

		event.preventDefault();
		updateReviews(paginationLink.href);
	});

	modal.addEventListener('click', (event) => {
		if (event.target === modal) {
			modal.close();
		}
	});

	modal.addEventListener('close', () => {
		triggers.forEach((trigger) => {
			trigger.setAttribute('aria-expanded', 'false');
		});

		activeTrigger?.focus();
		activeTrigger = null;
	});
});
